module.exports = __webpack_public_path__ + "img/logo.a329cef2.png";